export { DealerInfo } from './dealer-info.component';
